import type { IdentityCurrentStaffSessionResponse } from '@exylon/generated-contract-kernel/types';

type CanonicalStaffSession = IdentityCurrentStaffSessionResponse['result'];

/** The restaurant facts every Panel screen reads from one source, the
 * Identity session. The currency (EUR) and the calendar (Europe/Madrid) are
 * fixed, not facts. A restaurant without its owning franchise has no tenant
 * (the restaurant id never stands in for it). */
export interface RestaurantFacts {
  readonly restaurantId: string;
  readonly tenantId: string | null;
}
export function restaurantFacts(session: CanonicalStaffSession | null | undefined): RestaurantFacts | null {
  const restaurant = session?.restaurant;
  if (!session || !restaurant) return null;
  return { restaurantId: restaurant.id, tenantId: restaurant.franchise_id || null };
}
